import React, { useEffect, useRef, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import * as actions from '@/actions';
import AlertModal from './AlertModal';

const IdleStatusChecker = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const idleTimeRef = useRef(null);
  const sessionTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const [displayModal, setDisplayModal] = useState(false);

  const handleLogout = () => {
    setDisplayModal(false);
    dispatch(actions.logout.request());
    clearTimeout(sessionTimeoutRef.current);
  };

  const continueSession = () => {
    setDisplayModal(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  const timeRemainingToLogout = 2 * 60 * 1000;
  const onIdle = () => {
    if (isLoggedIn) {
      setDisplayModal(true);
      sessionTimeoutRef.current = setTimeout(() => handleLogout(), timeRemainingToLogout);
    }
  };

  const idleTimer = useIdleTimer({
    crossTab: true,
    ref: idleTimeRef,
    timeout: 13 * 60 * 1000,
    onIdle: onIdle
  });

  useEffect(() => {
    idleTimer.start();
  }, []);

  return (
    <>
      {
        displayModal ?
          <AlertModal
            visible={displayModal}
            handleLogout={handleLogout}
            continueSession={continueSession}
          /> : null
      }
    </>
  );
};

export default IdleStatusChecker;